module.exports = __webpack_public_path__ + "img/australia.6066d5c0.jpg";